import React, { useState } from 'react';
import {
  CapaErrorCode,
  CapaServiceType,
  Language,
  useRefreshMutation,
  useRegisterConnectUserMutation
} from '@generated/graphql';
import RegisterConnectDialogPresenter from './RegisterConnectDialogPresenter';
import { RegisterConnectDialogProps } from './types';
import useClient from '@hooks/useClient';
import jwtDecode from '@utils/jwtDecode';

const RegisterConnectDialogContainer = ({
  open,
  onClose,
  onOpenDialog
}: Pick<RegisterConnectDialogProps, 'open' | 'onClose' | 'onOpenDialog'>) => {
  const {
    clientState: { refreshToken },
    onUpdateToken
  } = useClient();
  const [checked, SetChecked] = useState(false);
  const [registerConnectUser] = useRegisterConnectUserMutation();

  const [refresh] = useRefreshMutation();

  const onCheck = (_: any, _checked: boolean) => SetChecked(_checked);

  const onSubmit = async (value: string) => {
    try {
      const { data } = await registerConnectUser({
        variables: {
          input: {
            userName: value,
            userLanguage: Language.Korean
          }
        }
      });

      const { data: token } = await refresh({
        variables: { refreshToken: refreshToken ?? '' }
      });

      const accessToken = token?.refresh.data?.accessToken;

      const refreshedToken = token?.refresh.data?.refreshToken;

      const jwt = jwtDecode();

      onUpdateToken({
        accessToken: accessToken,
        refreshToken: refreshedToken
      });

      if (
        data?.registerConnectUser.result === CapaErrorCode.Success &&
        jwt?.scopes.includes(CapaServiceType.Connect)
      ) {
        onOpenDialog('connectDrive');
      } else {
        return onClose();
      }
    } catch {
      return false;
    }
  };

  return (
    <RegisterConnectDialogPresenter
      open={open}
      checked={checked}
      onSubmit={onSubmit}
      onCheck={onCheck}
      onClose={onClose}
      onOpenDialog={onOpenDialog}
    />
  );
};

export default RegisterConnectDialogContainer;
